import catchAllErrors from './catchAllErrors';
import { convertISOToDottedFullDateString } from './date/convertDateFormat';

function getTimeDifference(startTime: string) {
  const start = new Date(startTime);

  // 날짜 문자열이 유효한지 확인
  if (Number.isNaN(start.getTime())) {
    catchAllErrors(new Error('Invalid date string on getTimeDifferenceTodayOnly'));
  }

  const now = Date.now();
  const difference = now - start.getTime();

  // 시간 차이를 밀리초에서 초로 변환
  const seconds = Math.floor(difference / 1000);
  if (seconds < 60) {
    return '방금 전';
  }

  // 시간 차이를 밀리초에서 분으로 변환
  const minutes = Math.floor(difference / 60000);
  if (minutes < 60) {
    return `${minutes}분 전`;
  }

  // 시간 차이를 밀리초에서 시간으로 변환
  const hours = Math.floor(difference / 3600000);
  if (hours < 24) {
    return `${hours}시간 전`;
  }

  // 시간 차이를 밀리초에서 일로 변환
  const days = Math.floor(difference / (3600000 * 24));
  return `${days}일 전`;
}

export default getTimeDifference;

export function getTimeDifferenceTodayOnly(startTime: string):
  | {
      i18nKey: 'nHoursAgo' | 'nMinutesAgo' | 'justNow' | 'yesterday';
      number: number;
    }
  | string {
  const start = new Date(startTime);

  // 날짜 문자열이 유효한지 확인
  if (Number.isNaN(start.getTime())) {
    catchAllErrors(new Error('Invalid date string on getTimeDifferenceTodayOnly'));
  }

  const now = new Date();
  const nowTime = now.getTime();
  const difference = nowTime - start.getTime();

  // 시간 차이를 밀리초에서 초로 변환
  const seconds = Math.round(difference / 1000);
  if (seconds < 300) {
    return {
      i18nKey: 'justNow',
      number: 0,
    };
  }

  // 시간 차이를 밀리초에서 분으로 변환
  const minutes = Math.round(difference / 60000);
  if (minutes < 60) {
    return {
      i18nKey: 'nMinutesAgo',
      number: minutes,
    };
  }

  // 시간 차이를 밀리초에서 시간으로 변환
  const hours = Math.round(difference / 3600000);
  if (hours < 24) {
    return {
      i18nKey: 'nHoursAgo',
      number: hours,
    };
  }

  // 날짜 비교를 위해 오늘과 시작 날짜의 연, 월, 일만 비교
  const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // 날짜 차이 계산
  const dateDiff = nowDate.getTime() - startDate.getTime();
  const days = dateDiff / (1000 * 60 * 60 * 24);

  // 어제에 해당하는 경우 처리
  if (days === 1) {
    return {
      i18nKey: 'yesterday',
      number: 0,
    };
  }

  // 그 외의 경우에는 nHoursAgo를 반환
  return convertISOToDottedFullDateString(startTime);
}
